import { render, staticRenderFns } from "./wax-carts-pkg-info.vue?vue&type=template&id=2c090bb8&"
import script from "./wax-carts-pkg-info.vue?vue&type=script&lang=js&"
export * from "./wax-carts-pkg-info.vue?vue&type=script&lang=js&"
import style0 from "./wax-carts-pkg-info.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c090bb8')) {
      api.createRecord('2c090bb8', component.options)
    } else {
      api.reload('2c090bb8', component.options)
    }
    module.hot.accept("./wax-carts-pkg-info.vue?vue&type=template&id=2c090bb8&", function () {
      api.rerender('2c090bb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/production-manage/wax-carts-pkg/wax-carts-pkg-info.vue"
export default component.exports